import {useMutation} from '@tanstack/react-query';
import {getLocalStorage} from '@/Utils/CommonUtils';
import ChessRestClient from '@/Api/ChessRestClient';
import useChatRestClient from '@/Api/ChatRestClient';

interface CaissaChatbotResponse {
  message: string;
}

export default function useGetCaissaChatbotResponse(
  handleOnSuccess?: (data: CaissaChatbotResponse) => void,
) {
  const ChatRestClient = useChatRestClient();
  const mutation = useMutation<
    CaissaChatbotResponse,
    Error,
    {user_message: string}
  >(
    async ({user_message}) => {
      const response = await ChatRestClient.post(
        '/gpt/v1/get_caissa_chatbot_response',
        {
          user_message,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
    },
  );

  return {
    ...mutation,
  };
}
